import type { FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import type { PartnerData } from '@jerry-serverless/analyticslib/partner';

import type { PartnerLogoType } from '../../utils/partner';
import { getPartnerLogoProps, CBAUTO } from '../../utils/partner';

interface PartnerLogoProps {
  className?: string;
  partnerName: PartnerLogoType;
}

/**
 * Partner Logo component
 */
const UnstyledPartnerLogo: FunctionComponent<PartnerLogoProps> = ({ className, partnerName }) => {
  const { partnerLogo, width } = getPartnerLogoProps(partnerName);

  return (
    <div className={className}>
      <img src={partnerLogo} alt={`${partnerName}`} style={{ width: width }} />

      {/* Lyft */}
      {partnerName === 'lyft' && (
        <>
          <FiberManualRecordIcon className="lyftJerryDot" />
          <div className="lyftJerryTitle">Jerry</div>
        </>
      )}
    </div>
  );
};

export const PartnerLogo = styled(UnstyledPartnerLogo)`
  display: flex;
  align-items: center;
  justify-content: center;

  .lyftJerryDot {
    font-size: 0.5rem;
    color: #d9e0e9;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .lyftJerryTitle {
    color: #000000;
    font-weight: 450;
    font-size: 1.375rem;
    line-height: 1.125rem;
    letter-spacing: -0.17px;
  }
`;

/**
 * Helper function to grab partner logo in util file.
 * @param partnerName
 */
export const getPartnerLogo = (partner: PartnerData): JSX.Element | null => {
  let partnerName: PartnerLogoType = partner.partner;

  /**
   * Note: 'cbautogroup' partner wants to show different logo per campaign
   * Also cbautogroup has two flows, weblink and widget with different utm_campaign values.
   */
  if (partner.partner === 'cbautogroup') {
    partnerName =
      partner.data.utm_campaign === 'advantage' || partner.data.utm_campaign === 'advantage_widget'
        ? CBAUTO.cbautogroupadvantage
        : CBAUTO.cbautogroupunion;
  }

  return <PartnerLogo partnerName={partnerName} />;
};
